export default "__VITE_ASSET__2939739f__"